import React from "react";

import { useTranslation } from "react-i18next";

import { Material } from "../../../models/material";
import { QuotedItem, RoomJob } from "../../../models/sales";
import { handleGetConvertValue } from "../../../util/converts";
import { getMeasurement, getWeightMeasurement } from "../../../util/getMeasurement";
import { Wrapper, Title, List, ListItem } from "./styles";

interface InfoHeaderInventoryProps {
  inventory?: RoomJob[];
  onCustomerView?: boolean;
}

export const InfoHeaderInventory = (props: InfoHeaderInventoryProps) => {
  const { inventory, onCustomerView = false } = props;
  const { t: translate } = useTranslation();

  const measurement = getMeasurement();
  const measurementWeight = getWeightMeasurement();

  const handleGetTotalQuantity = (attribute: string): any => {
    let totalOfItems = 0;
    let totalOfMaterials = 0;

    inventory?.forEach((room: RoomJob) => {
      if (attribute === "volume") {
        totalOfItems += room.itemsJob.reduce(
          (total: number, item: QuotedItem) =>
            total + Number(item.itemJob.volume) * Number(item.itemJob.quantity),
          0
        );
        totalOfMaterials += room.materials.reduce(
          (total: number, material: Material) =>
            total +
            (material?.serviceBooking?.isItem
              ? Number(material.volume) * Number(material.quantity)
              : 0),
          0
        );
      } else if (attribute === "weight") {
        totalOfItems += room.itemsJob.reduce(
          (total: number, item: QuotedItem) =>
            total +
            Number(item.itemJob.weight ? item.itemJob.weight : 0) * Number(item.itemJob.quantity),
          0
        );
        totalOfMaterials += room.materials.reduce(
          (total: number, material: Material) =>
            total +
            (material?.serviceBooking?.isItem
              ? Number(material.weight ? material.weight : 0) * Number(material.quantity)
              : 0),
          0
        );
      } else {
        totalOfItems += room.itemsJob.reduce(
          (total: number, item: QuotedItem) => total + Number(item.itemJob.quantity),
          0
        );
        totalOfMaterials += room.materials.reduce(
          (total: number, material: Material) =>
            total + (material?.serviceBooking?.isItem ? Number(material.quantity) : 0),
          0
        );
      }
    });

    return Number(totalOfItems + totalOfMaterials);
  };

  return (
    <Wrapper>
      <Title data-cy="page-title">
        {onCustomerView ? translate("inventory") : translate("quotedInventory")}
      </Title>
      <List>
        <ListItem data-cy="items-quantity">
          <span>{translate("totalQty")}</span>
          <span className="value">{handleGetTotalQuantity("quantity")}</span>
        </ListItem>
        <ListItem data-cy="items-volume">
          <span>{translate("totalVolume")}</span>
          <span className="value">
            {Number(
              handleGetConvertValue(
                handleGetTotalQuantity("volume"),
                measurement?.code,
                measurement?.decimalPlaces
              )
            )?.toFixed(2)}
            {measurement?.code}
          </span>
        </ListItem>
        <ListItem data-cy="item-weight">
          <span>{translate("totalWeight")}</span>
          <span className="value">
            {Number(
              handleGetConvertValue(
                handleGetTotalQuantity("weight"),
                measurementWeight?.code || "kg",
                measurementWeight?.decimalPlaces
              )
            )?.toFixed(2)}
            {measurementWeight?.code || "kg"}
          </span>
        </ListItem>
      </List>
    </Wrapper>
  );
};
